// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1z80p","modalFooterButton":"ModalNotes_modalFooterButton__2e4m3"};